import { useTranslation } from '../../hooks';
import { LoaderContainer } from './styles';

/**
 * InfiniteScrollLoader Component
 * A loading indicator component that displays a spinning icon and translated loading message,
 * typically used for infinite scroll loading states
 *
 * @component
 * @returns {JSX.Element} Loading indicator with spinning icon and message
 *
 * @example
 * // Basic usage
 * <InfiniteScrollLoader />
 *
 * // Will render a spinning circle icon with translated "Loading..." message
 */
export function InfiniteScrollLoader() {
  const { t } = useTranslation('common');
  return (
    <LoaderContainer>
      <i className="fas fa-circle-notch fa-spin" />
      {t('loader_message')}
    </LoaderContainer>
  );
}
